import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { LanguageProvider } from "./i18n/LanguageContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Calculators from "./pages/Calculators";
import Legal from "./pages/Legal";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/calculateurs" element={<Calculators />} />
              <Route path="/rechner" element={<Calculators />} />
              <Route path="/calculators" element={<Calculators />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/:slug" element={<Legal />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid rgba(255,255,255,0.15)",
              background: "#1F1F23",
              color: "#F5F5F5",
              fontFamily: "IBM Plex Mono, monospace",
              fontSize: "13px",
              letterSpacing: "0.04em",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
